import httpClient from './httpClient';

const plantillasContratoService = {
  async obtenerVariablesDisponibles() {
    try {
      const response = await httpClient.get('/plantillas-contrato/variables-disponibles');
      return {
        success: true,
        data: response.data.data || [],
        fuentes: response.data.fuentes || [],
      };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.message || 'Error al obtener variables disponibles',
        data: [],
        fuentes: [],
      };
    }
  },

  async obtenerPlantillas(empresaId) {
    try {
      const response = await httpClient.get(`/plantillas-contrato/empresa/${empresaId}`);
      return {
        success: true,
        data: response.data.data || [],
      };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.message || 'Error al obtener plantillas',
        data: [],
      };
    }
  },

  async obtenerPlantilla(id) {
    try {
      const response = await httpClient.get(`/plantillas-contrato/${id}`);
      return {
        success: true,
        data: response.data.data,
      };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.message || 'Error al obtener plantilla',
      };
    }
  },

  async crearPlantilla(payload) {
    try {
      const response = await httpClient.post('/plantillas-contrato', payload);
      return {
        success: true,
        data: response.data.data,
        message: response.data.message || 'Plantilla creada exitosamente',
      };
    } catch (error) {
      const data = error.response?.data || {};
      const mensaje =
        data.message && data.error && data.message !== data.error
          ? `${data.message}: ${data.error}`
          : data.message || data.error || 'Error al crear plantilla';

      return {
        success: false,
        error: mensaje,
        errors: data.errors,
      };
    }
  },

  async actualizarPlantilla(id, payload) {
    try {
      const response = await httpClient.put(`/plantillas-contrato/${id}`, payload);
      return {
        success: true,
        data: response.data.data,
        message: response.data.message || 'Plantilla actualizada exitosamente',
      };
    } catch (error) {
      const data = error.response?.data || {};
      const mensaje =
        data.message && data.error && data.message !== data.error
          ? `${data.message}: ${data.error}`
          : data.message || data.error || 'Error al actualizar plantilla';

      return {
        success: false,
        error: mensaje,
        errors: data.errors,
      };
    }
  },

  async eliminarPlantilla(id) {
    try {
      const response = await httpClient.delete(`/plantillas-contrato/${id}`);
      return {
        success: true,
        message: response.data.message || 'Plantilla eliminada exitosamente',
      };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.message || 'Error al eliminar plantilla',
      };
    }
  },

  async obtenerCatalogoCopia(empresaDestinoId) {
    try {
      const response = await httpClient.get(`/plantillas-contrato/empresa/${empresaDestinoId}/catalogo-copia`);
      return {
        success: true,
        data: response.data.data || [],
      };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.message || 'Error al obtener plantillas de otras empresas',
        data: [],
      };
    }
  },

  async copiarPlantillas(empresaDestinoId, plantillaIds) {
    try {
      const response = await httpClient.post('/plantillas-contrato/copiar', {
        empresa_destino_id: empresaDestinoId,
        plantilla_ids: plantillaIds,
      });
      return {
        success: true,
        data: response.data.data || [],
        message: response.data.message || 'Plantillas copiadas exitosamente',
      };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.message || 'Error al copiar plantillas',
        errors: error.response?.data?.errors,
      };
    }
  },
};

export default plantillasContratoService;
